import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { BetPlacementError } from '../../../errors/bet-placement-error';

export interface IPickUpdater {
    updatePick(pick: BetslipPick, error: BetPlacementError): void;
}

export abstract class PickUpdaterBase<TError extends BetPlacementError> implements IPickUpdater {
    updatePick(pick: BetslipPick, error: TError): void {
        if (pick instanceof BetslipV1Pick) {
            this.updateV1Pick(pick, error);
        }
        if (pick instanceof BetslipV2Pick) {
            this.updateV2Pick(pick, error);
        }
        if (BaseBetslipGroupPick.isPick(pick)) {
            this.updateGroupPick(pick, error);
        }
    }

    protected abstract updateV1Pick(pick: BetslipV1Pick, error: TError): void;

    protected abstract updateV2Pick(pick: BetslipV2Pick, error: TError): void;
    protected abstract updateGroupPick(pick: BaseBetslipGroupPick, error: TError): void;
}
